import { firebaseRequest, downloadRequest } from '@/utils/request'

/* 客訴事件 */
export const reqComplainList = (params) =>
  firebaseRequest.get('customer_complaint/list', { params })

export const reqAddComplain = (payload) =>
  firebaseRequest.post(`customer_complaint`, payload)

export const reqUpdateComplain = (id, payload) =>
  firebaseRequest.put(`customer_complaint/update?id=${id}`, payload)

export const reqDeleteComplain = (id, data) =>
  firebaseRequest.delete(`customer_complaint/remove?id=${id}`, { data })

/* 客訴種類 */
export const reqType = (teamCode) =>
  firebaseRequest.get(`complaint?code=${teamCode}`)

export const reqAddType = (payload) =>
  firebaseRequest.post(`complaint`, payload)

export const reqEditType = (typeId, payload) =>
  firebaseRequest.put(`complaint/update?id=${typeId}`, payload)

export const reqDeleteType = (typeId, payload) =>
  firebaseRequest.delete(`complaint/seal?id=${typeId}`, { data: payload })

/* 客訴事件下載資料 */

export const reqDownload = (params) =>
  downloadRequest.post('excel/customer_complaint-excel', null, { params })



// WEBPACK FOOTER //
// ./src/api/customerComplain/index.js